export default "__VITE_PUBLIC_ASSET__ab3636ef__"